import { Fade, IconButton } from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import create, { UseStore } from 'zustand';
import React from 'react';

type ToggleButtonData = {
  active: boolean;
};
export type ToggleButtonApi = UseStore<ToggleButtonData>;

export function toggleButtonApi(active = true): ToggleButtonApi {
  return create<ToggleButtonData>(() => ({ active }));
}

type ToggleButtonProps = {
  api: ToggleButtonApi;
  onClick?: () => void;
  activeIcon?: any;
  inActiveIcon?: any;
};

export function ToggleButton(props: ToggleButtonProps) {
  const { api, onClick, activeIcon, inActiveIcon } = props;
  const active = api((s) => s.active);
  const shouldRender = activeIcon ? active : !active;

  const onToggle = () => {
    api.setState({ active: !active });

    if (onClick) {
      onClick();
    }
  };
  return (
    shouldRender && (
      <Fade in={shouldRender} timeout={2000}>
        <IconButton onClick={onToggle}>{activeIcon || inActiveIcon}</IconButton>
      </Fade>
    )
  );
}

type ToggleMenuProps = ToggleButtonProps & {
  active?: boolean;
  iconColor?: string;
};
export function ToggleMenu(props: ToggleMenuProps) {
  const { active, iconColor } = props;
  return (
    <ToggleButton
      {...props}
      activeIcon={active ? <MenuIcon htmlColor={iconColor} id="open_menu_icon" /> : undefined}
      inActiveIcon={active ? undefined : <MenuIcon htmlColor={iconColor} id="open_menu_icon" />}
    />
  );
}
